
import XHeader from 'vux/src/components/x-header/index.vue'
import Actionsheet from 'vux/src/components/actionsheet/index.vue'
import Search from 'vux/src/components/search/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'


export default {
components: {
XHeader,
Actionsheet,
Search,
Group,
Cell
},
data() {
return {
showTitle: this.$route.query.title,
parentClassId: this.$route.query.classid,
subClassId: this.$route.query.subclassid,
classList: [],
subClassList: [],
courseList: [],
currentCourse: {},
district: false,
menuDistrict: [],
searchResults: [],
searchValue: ""
};
},
created() {
this.getData();


this.$http({
method: "post",
url: "wxexam.ashx?op=LoadDistrict"
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
response.data.data.forEach(dc => {
this.menuDistrict.push(dc.cdcname);
});
}
})
.catch(function(error) {
console.log("error:" + error);
});
},
methods: {
getData() {
this.showTitle = this.$route.query.title;
this.parentClassId = this.$route.query.classid;
this.subClassId = this.$route.query.subclassid;
this.classList = [];
this.subClassList = [];
this.courseList = [];
this.currentCourse = {};
this.district = false;

this.$vux.loading.show({
text: "请稍候..."
});

if (this.parentClassId > 0) {
this.getSubClassList();
} else if (this.subClassId > 0) {
this.getCourseList();
} else {
this.getClassList();
}
},
getClassList() {

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadClassList"
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.classList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
getSubClassList() {

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadSubClassList",
params: {
parentClassId: this.parentClassId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.subClassList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
getCourseList() {

this.$http({
method: "post",
url: "wxexam.ashx?op=LoadCourseList",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
subclassid: this.subClassId
}
})
.then(response => {
if (response.status == 200 && response.data.errcode == 0) {
this.courseList = response.data.data;
}
this.$vux.loading.hide();
})
.catch(function(error) {
console.log("error:" + error);
this.$vux.loading.hide();
});
},
classClick(classItem) {
this.$router.push({
path: "/ClassList",
query: {
title: classItem.ccoursecname,
classid: classItem.iclassid
}
});
},
subClassClick(subClassItem) {
this.$router.push({
path: "/ClassList",
query: {
title: subClassItem.csubclassname,
subclassid: subClassItem.isubclassid
}
});
},
courseClick(courseItem) {
this.$http({

method: "post",
url: "wxexam.ashx?op=ExistDistrictInCourse",
params: {
courseId: courseItem.icourseid
}
})
.then(response => {
if (response.status == 200) {
this.currentCourse = courseItem;
if (response.data.data == 1) {
this.district = true;
} else {

this.addCourse();
}
}
})
.catch(function(error) {
console.log("error:" + error);
});
},

showDistrict(menuKey, menuItem) {
var userInfo = this.$store.getters.getUserInfo;
if (userInfo != undefined) {
userInfo.DcCode = menuKey;
this.$store.commit("$_setUserInfo", userInfo);
}

this.addCourse();
},

addCourse() {
var classInfo = this.$store.getters.getClassInfo;
if (classInfo != undefined) {
classInfo.CourseId = this.currentCourse.icourseid;
classInfo.CourseName = this.currentCourse.ccoursename;
classInfo.IsNew = true;
this.$store.commit("$_setClassInfo", classInfo);
}

this.$http({
method: "post",
url: "wxexam.ashx?op=AddMyCourse",
params: {
cusId: this.$store.getters.getUserInfo.CusId,
courseId: this.currentCourse.icourseid
}
})
.then(response => {
if (response.status == 200) {
}
})
.catch(function(error) {
console.log("error:" + error);
});

this.$router.push({ path: "/" });
},
searchSubmit() {
if (this.searchValue.length == 0) {
this.searchResults = [];
return;
}

this.$http({
method: "post",
url: "wxexam.ashx?op=SearchCourseList",
params: {
searchStr: this.searchValue
}
})
.then(response => {
if (response.status == 200) {
this.searchResults = response.data.data;
}
})
.catch(function(error) {
console.log("error:" + error);
});
}
},
computed: {
title: function() {
if (this.showTitle != undefined) {
return this.showTitle;
}

return "考试分类";
}
},
watch: {

$route: "getData"
}
};



// WEBPACK FOOTER //
// ./src/components/ClassList.vue